// Home.vue

<template>
  <v-container>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <v-list-item :to="$root.menu.homePage">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Accueil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/souscription/choixcategorieoffre">
          <v-list-item-action>
            <v-icon>mdi-pen-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Nouvelle souscription</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item v-on:click="pendingList()">
          <v-list-item-action>
            <v-icon>mdi-folder-clock-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contrats en attente</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item v-on:click="$root.logout()">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark :color="barColor">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-xs-and-down">CGR Webapp</span> <span class="font-weight-thin text-sm-body-1">v{{version}}</span>



      </v-toolbar-title>

      <v-spacer></v-spacer>
          <v-chip  outlined small>
            <v-avatar left>
              <v-icon>mdi-earth</v-icon>
            </v-avatar>{{ $root.user.site }}
            <v-menu offset-y>
         
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            
              <v-list>
                <v-list-item  
                v-for="(value, key) in $root.user.marqueTab"
                  :key="key"  >        
                    <v-list-item-title v-on:click="changeSite(key,value)">{{ key }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item>
                    <v-list-item-title v-on:click="changeSite('GPE')">GPE</v-list-item-title>
                </v-list-item>
                  <v-list-item>
                    <v-list-item-title v-on:click="changeSite('GUY')">GUY</v-list-item-title>
                </v-list-item> 
              -->
              </v-list>
            </v-menu>
          </v-chip>
          
          <v-chip            
            class="ma-2"
            outlined
            small
          >
            <v-avatar left>
              <v-icon>mdi-briefcase-account-outline</v-icon>
            </v-avatar>TLV
          </v-chip>
      <v-chip small outlined>{{$root.user.role}}</v-chip>

      <v-chip outlined small>{{$root.user.codevendeur}} - {{$root.user.prenom}} {{$root.user.nom}}</v-chip>

      <v-menu offset-y>
         
      <template v-slot:activator="{ on, attrs }">
         <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account-check</v-icon>
         </v-btn>
      </template>

      <v-list>
         <v-list-item v-on:click="$root.confLogout = true">
            <v-list-item-action>
               <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-title>Déconnexion</v-list-item-title>
         </v-list-item>
      </v-list>
      </v-menu>

    </v-app-bar>
   
   <v-dialog v-model="$root.confLogout" max-width="360">
      <v-card>
         <v-card-title class="headline">Déconnexion</v-card-title>
         <v-card-text>Etes-vous sûr(e) de vouloir fermer la session utilisateur en cours ?</v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="tertiary" text @click="$root.confLogout = false">Non</v-btn>
            <v-btn color="tertiary" text @click="$root.logout()">Oui</v-btn>
         </v-card-actions>
      </v-card>
   </v-dialog>

  </v-container>
</template>
<script>
import {AppService} from '../../../providers/AppService.js';
const appService = new AppService();

export default {
  name: "TlvBandeau",

  data: () => ({
    drawer: null,
    barColor: 'secondary',
    user: null,
    version: null,
    typoClient: 'P'
  }),
  beforeMount() {},
  
  mounted: function () {
    this.version = appService.APP_VERSION;
   
    
    this.typoClient = 'B';    // clients pro
    this.barColor = 'violet lighten1';
    
  },
  methods: {
    /*init: function(){
      this.user  = this.$globalService.getUser();
    }*/
    updatePassword: function () {
      this.$router.push({ name: "UpdatePassword" });
    },
    adminVadeurs: function () {
      this.$router.push({ name: "VadListe" });
    },
    pendingList: function () {
      this.$router.push({ name: "PendingList" });
    },
    changeSite: function (site,marque) {
      if(!sessionStorage.getItem('souscription')){
        const sessionUser = this.$globalService.getUser();
        sessionUser.site = site;
        sessionUser.marque = marque;
        
        this.$root.user = sessionUser;
        this.$globalService.setUser(sessionUser);
      
         this.$router.push({ name: "TlvHome" });
        
      }else{
        this.$dialog.notify.warning("Souscription en cours! Impossible de changer de département", {
        position: 'bottom',
        timeout: 5000
        });
        
        return;
      }


    }
  },
};
</script>